import styled from 'styled-components';

export const TaskLocationsTableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ goefenceTableHeader }) =>
    goefenceTableHeader
      ? '25% 30% 100px 100px 1fr 1fr'
      : '18% 135px 117px 27% 135px 135px 90px 100px'};
  grid-column-gap: 20px;
  justify-content: flex-start;
  padding: 0 25px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};

  @media screen and (max-width: 1400px) {
    grid-template-columns: ${({ goefenceTableHeader }) =>
      goefenceTableHeader
        ? '25% 30% 100px 100px 1fr 1fr'
        : '22% 90px 90px 18% 110px 110px 72px 100px'};
  }
`;

export const TaskLocationsTableRowContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ goefenceTableHeader }) =>
    goefenceTableHeader
      ? '25% 30% 100px 100px 1fr 1fr'
      : '18% 135px 117px 27% 135px 135px 90px 100px'};
  grid-column-gap: 20px;
  justify-content: flex-start;
  padding: 0 25px;
  :nth-of-type(even) {
    background-color: #f8f9fc;
  }
  @media screen and (max-width: 1400px) {
    grid-template-columns: ${({ goefenceTableHeader }) =>
      goefenceTableHeader
        ? '25% 30% 100px 100px 1fr 1fr'
        : '22% 90px 90px 18% 110px 110px 72px 100px'};
  }
`;
